// Pagination
export const DEFAULT_PAGE = 1;
export const DEFAULT_ROWS = 0;
export const GET_ALL_RECORDS = -1;
export const PAGINATION_NUMBER = 2;

// Timeouts
export const RESPONSE_MESSAGE_VISIBILITY_MS = 3000;

/**
 * Quill empty string (when there is no text displaying, Quill outputs this value)
 */
export const QUILL_EMPTY_STRING = "<p><br></p>";
